.playArea {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 2560px;
    height: 1440px;
}
.bgImg {
    position: absolute;
    inset: 0;
    pointer-events: none;
}
.widgetClickArea {
    position: absolute;
    background-color: transparent;
    border: 0;
}
.widgetView {
    position: absolute;
    inset: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: rgba(0, 0, 0, 0.8);

    z-index: 5;
}
.widgetViewInstructions {
    position: absolute;
    bottom: 250px;
    left: 250px;
    color: white;
    font-size: 24px;
}

.customPointerDialog {
    width: 100%;
    height: 100%;
    background: transparent;
    pointer-events: none;
    z-index: 100;
}
.customPointer {
    position: absolute;
    pointer-events: none;
    z-index: 100;
    top: 0;
    left: 0;
    transform-origin: top left;
    background: transparent;
    margin: 0;
    border: 0;
}
.customPointer[src=""] {
    display: none;
}

.YouWinScreen {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    font-size: 40px;
    z-index: 10;
}

.YouWinBG {
    z-index: 11;
}

.Credits
{ 
    font-family: "Special Elite", system-ui;
    z-index: 12;
    position: absolute;
    left: 1500px;
    top: 150px;
    line-height: 48px;
}